export default "__VITE_ASSET__CoY9fIpZ__"